<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Tunnel Configurations
              <router-link
                :to="{ name: 'TunnelConfigurationAdd' }"
                class="btn ml-auto"
                v-if="actionCreate"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Tunnel Configurations</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <el-dropdown
                split-button
                :trigger="'click'"
                @command="handleSelectedRows"
                type="primary"
                v-if="this.selected_row.length"
                class="mr-1"
              >
                {{ this.selected_row.length }}
                {{ "item" | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete">Delete</el-dropdown-item>
                  <el-dropdown-item command="enable">Enable</el-dropdown-item>
                  <el-dropdown-item command="disable">Disable</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div class="card-tools">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common m-2px">
                        <i class="fas fa-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()">
                        <i class="fas fa-undo"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <h6 v-if="organizationId == 1">Total Item: {{ list.total }}</h6>
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 10px">
                        <input
                          type="checkbox"
                          v-model="is_selected_all"
                          @click="selectedRowAll()"
                        />
                      </th>
                      <th v-if="organizationId == 1">Audra</th>
                      <th>State</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Tunnel IP</th>
                      <!-- <th>Re. Tunnel IP</th> -->
                      <th>IPsec</th>
                      <th>Admins</th>
                      <th>P2P</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td>
                        <input
                          type="checkbox"
                          v-model="selected_row"
                          :value="{ id: val.id, accountId: val.accountId }"
                        />
                      </td>
                      <td v-if="organizationId == 1">
                        {{ val.device_name }}
                      </td>
                      <td>{{ val.tunnel_status.toUpperCase() }}</td>
                      <td>{{ tunnelName(val) }}</td>
                      <td>{{ val.interface_type.toUpperCase() }}</td>
                      <td>{{ tunnelIP(val) }}</td>
                      <!-- <td>{{ remoteTunnelIP(val) }}</td> -->
                      <td>
                        {{
                          val.interface_type == "SITETOSITE"
                            ? val.ipsec_is_active == 1
                              ? "CONNECTED"
                              : "DISCONNECTED"
                            : val.ipsec_encryption == "0"
                            ? "NA"
                            : val.ipsec_is_active == 1
                            ? "CONNECTED"
                            : "DISCONNECTED"
                        }}
                      </td>
                      <td>{{ isActive(val) }}</td>
                      <td>{{ isActiveP2P(val) }}</td>
                      <td class="text-right">
                        <router-link
                          v-if="actionView == true && 1 == 0"
                          :to="{
                            name: 'TunnelConfigurationShow',
                            params: { id: val.id },
                          }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link>
                        <router-link
                          v-if="actionEdit == true || checkEditPermission(val)"
                          :to="{
                            name: 'TunnelConfigurationEdit',
                            params: { id: val.id },
                          }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <a
                          v-if="actionDelete == true || checkDeletePermission(val)"
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteObject(val.id, val.accountId, index)"
                          ><i class="icon-trash"></i
                        ></a>
                        <a
                          v-if="
                            (val.interface_type == 'VTI' ||
                              val.interface_type == 'GRE') &&
                            val.is_active_p2p === 1
                          "
                          class="btn btn-danger btn-sm m-2px"
                          href="javascript:void(0)"
                          @click="
                            tunnelChange(
                              val.id,
                              val.accountId,
                              val.tunnel_name,
                              val.interface_type,
                              'down'
                            )
                          "
                          title="down"
                          ><i class="fa fa-arrow-down"></i
                        ></a>
                        <a
                          v-else-if="
                            val.interface_type == 'SITETOSITE' && val.is_active_p2p === 1
                          "
                          class="btn btn-danger btn-sm m-2px"
                          href="javascript:void(0)"
                          @click="
                            tunnelChange(
                              val.id,
                              val.accountId,
                              val.tunnel_name,
                              val.interface_type,
                              'down'
                            )
                          "
                          title="down"
                          ><i class="fa fa-arrow-down"></i
                        ></a>
                        <a
                          v-else
                          class="btn btn-edit"
                          href="javascript:void(0)"
                          @click="
                            tunnelChange(
                              val.id,
                              val.accountId,
                              val.tunnel_name,
                              val.interface_type,
                              'up'
                            )
                          "
                          title="up"
                          ><i class="icon-arrow-up-circle"></i
                        ></a>

                        <router-link
                          v-if="actionCopy == true || checkEditPermission(val)"
                          :to="{
                            name: 'TunnelConfigurationCopy',
                            params: { id: val.id, isCopy: true },
                          }"
                          class="btn btn-edit"
                        >
                          <i class="icon-copy"></i>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "TunnelConfiguration",
  metaInfo: {
    title: "TunnelConfigurations | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: true,
    actionTunnelChange: true,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    actionCopy: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
    isActiveStyle: {},
    isActiveP2PStyle: {},
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/tunnelconfigurations";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/tunnelconfigurations"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    deleteObject: function (id, accountId, index) {
      const _this = this;
      const delete_api_url = "/tunnelconfigurations/" + id;

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url, {
                params: {
                  accountId: accountId,
                },
              })
              .then((response) => {
                _this.list.data.splice(index, 1);
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
              })
              .catch((error) => {
                _this.is_loading = false;
                console.log(error);
                _this.$swal.fire("Failed!", "failed to delete.", "error");
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/tunnelconfigurations-export", {
          params: { userAccountId: LocalStorage.get("accountId") },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "tunnelconfigurations.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },
    selectedRowAll: function () {
      const isSelectedAll = (this.is_selected_all = !this.is_selected_all);
      if (isSelectedAll) {
        var items = [];
        this.list.data.forEach(function (item) {
          items.push({ id: item.id, accountId: item.accountId });
        });
        this.selected_row = items;
      } else {
        this.selected_row = [];
      }
    },
    handleSelectedRows(command) {
      let notificationMessage;
      let notificationTitle;
      const _this = this;

      if (command === "delete") {
        notificationMessage = "Data deleted successfully";
        notificationTitle = "Deleted Successfully";
      } else {
        notificationMessage = "Data Updated successfully";
        notificationTitle = "Updated Successfully";
      }

      axios({
        method: "POST",
        url: "/tunnelconfigurations-bulk-action",
        data: { ids: this.selected_row, action: command },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          Notification.success({
            title: notificationTitle,
            message: notificationMessage,
            type: "success",
          });
          // this.initialize();
        })
        .catch((errors) => {
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.errors.message);
          } else if (errors.response.data) {
            _this.$toaster.error(errors.response.data.message);
          }
        })
        .finally(() => {
          this.is_selected_all = false;
          this.selected_row = [];
          this.initialize();
        });
    },

    tunnelName(val) {
      if (val.interface_type == "GRE") {
        return val.tunnel_name ? val.tunnel_name.toUpperCase() : "";
      } else if (val.interface_type == "VTI") {
        return val.vti_name ? val.vti_name.toUpperCase() : "";
      } else return val.sitetosite_name ? val.sitetosite_name.toUpperCase() : "";
    },

    tunnelIP(val) {
      if (val.interface_type == "GRE") {
        return val.tunnel_ip ? val.tunnel_ip.toUpperCase() : "";
      } else if (val.interface_type == "VTI") {
        return val.vti_tunnel_ip ? val.vti_tunnel_ip.toUpperCase() : "";
      } else {
        return val.sitetosite_local_network
          ? val.sitetosite_local_network.toUpperCase()
          : "";
      }
    },

    remoteTunnelIP(val) {
      if (val.interface_type == "GRE") {
        return val.remote_tunnel_ip ? val.remote_tunnel_ip.toUpperCase() : "";
      } else if (val.interface_type == "VTI") {
        return val.vti_remote_tunnel_ip ? val.vti_remote_tunnel_ip.toUpperCase() : "";
      } else {
        return val.sitetosite_remote_network
          ? val.sitetosite_remote_network.toUpperCase()
          : "";
      }
    },

    isActive(val) {
      this.isActiveStyle = {};
      // this.isActiveStyle['font-weight'] = 'bold'
      if (val.interface_type === "SITETOSITE") {
        return "NA";
      }

      if (val.is_active == 1) {
        // this.isActiveStyle.color = '#069E7C';
        return "UP";
      }
      // this.isActiveStyle.color = '#DA1628';
      return "DOWN";
    },

    isActiveP2P(val) {
      this.isActiveP2PStyle = {};
      // this.isActiveP2PStyle['font-weight'] = 'bold';
      if (val.interface_type === "SITETOSITE") {
        return "NA";
      } else {
        if (val.is_active_p2p == 1) {
          // this.isActiveP2PStyle.color = '#069E7C';
          return "UP";
        } else {
          // this.isActiveP2PStyle.color = '#DA1628';
          return "DOWN";
        }
      }
    },

    tunnelChange(id, accountId, tunnel_name, interface_type, is_active_p2p) {
      this.is_loading = true;
      let status = "";
      if (interface_type == "GRE") {
        if (is_active_p2p == "down") {
          status = "down";
        } else {
          status = "up";
        }
      } else {
        if (is_active_p2p == "down") {
          status = "down";
        } else {
          status = "up";
        }
      }

      axios({
        method: "POST",
        url: "/change-tunnel",
        data: {
          id: id,
          accountId: accountId,
          gre_name: tunnel_name,
          type: interface_type,
          status: status,
        },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          Notification.success({
            title: status,
            message: "Changed Successfully",
            type: "success",
          });
          setTimeout(() => {
            Notification.close();
          }, 1000);
        })
        .catch((errors) => {
          if (!_.isEmpty(errors.response) && errors.response.status === 500) {
            this.$toaster.error(errors.response.data.message);
          }
        })
        .finally(() => {
          this.is_loading = false;
          this.initialize();
        });
    },
  },
};
</script>
